import React from 'react';
import { Row } from 'mage-components';
import { HorizontalWrapper } from 'moet-core';
import { SpacerVertical, SpacerHorizontal } from '@klarna/bubble-ui';
import { ContainerTemplate, SummarySection, CallToActionButton, SecondaryButton, } from '@/components';
import { WithTermsAndConditions, } from '@/bpc/components/HOCs/WithTermsAndConditions';
import { OnboardingSummaryFieldComponent } from './OnboardingSummaryFieldComponent';
const tPrefixButtons = 'products-fe.general.buttons';
class _OnboardingSummaryComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = { ctaClicked: false, errorOnSubmit: null, isLoading: false };
        this.onSubmit = this.onSubmit.bind(this);
    }
    onSubmit() {
        const { onSubmit, onboarding, onSubmitTermsAndConditionsFn, missingTermsValidation, hasTermsToAgree, } = this.props;
        // Early return - missing accept terms OR has already accepted terms
        if (missingTermsValidation) {
            this.setState({ ctaClicked: true, errorOnSubmit: null });
            return;
        }
        this.setState({ isLoading: true, errorOnSubmit: null });
        (hasTermsToAgree ? onSubmitTermsAndConditionsFn() : Promise.resolve())
            .then(() => onboarding.submitApplication())
            .then(() => {
            this.setState({ isLoading: false });
            return onSubmit();
        })
            .catch(error => {
            this.setState({ isLoading: false, errorOnSubmit: error });
            // Scroll to the top
            window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        });
    }
    render() {
        const { bpcPayloadWithTerms, onSummaryPageBack, t, error, onboarding, TermsAndConditionsComponent, } = this.props;
        const { errorOnSubmit, isLoading, ctaClicked } = this.state;
        const { has_agreed_terms_and_conditions: hasAcceptedTerms } = bpcPayloadWithTerms || {};
        return (React.createElement(ContainerTemplate, { title: t('group.summary.title'), error: error || errorOnSubmit },
            onboarding.onboardingGroups
                .filter(g => g.isApplicable())
                .map(onboardingGroup => (React.createElement(React.Fragment, { key: onboardingGroup.groupId },
                React.createElement(SummarySection, { title: t(onboardingGroup.labelTitle, {}, onboardingGroup.fallbackTitle) },
                    React.createElement(Row, null, onboardingGroup.fields.map(fields => fields.map(field => (React.createElement(OnboardingSummaryFieldComponent, { field: field, key: field.absolutePath, t: t, value: onboardingGroup.getValueForField(field.absolutePath) })))))),
                React.createElement(SpacerVertical, { medium: true })))),
            React.createElement(SpacerVertical, { medium: true }),
            React.createElement(TermsAndConditionsComponent, { isLoading: isLoading, ctaClicked: ctaClicked }),
            React.createElement(HorizontalWrapper, { display: "inline-flex", alignItems: "center", justifyContent: "flex-end" },
                React.createElement(SecondaryButton, { onClick: onSummaryPageBack }, t(`${tPrefixButtons}.back`)),
                React.createElement(SpacerHorizontal, { medium: true }),
                React.createElement(CallToActionButton, { onClick: this.onSubmit, loading: isLoading, disabled: hasAcceptedTerms }, t(`${tPrefixButtons}.submit_application`)))));
    }
}
export const OnboardingSummaryComponent = WithTermsAndConditions(_OnboardingSummaryComponent);
